import { Box, Button, Container, Dialog, Divider, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./index.scss";
import closeIcon from "../../../../../../assets/icon-xout-black.svg";
import {
  deleteAutoPaymentMethod,
  deleteBankPaymentMethod,
  setSelectDeletePrimaryPaymentMethod,
  onAddEditPaymentMethodLoadingStart,
  onAddEditPaymentMethodLoadingStop
} from "../../../../../../SharedContextStore/slices/paymentMethods";
import { useAppDispatch, useAppSelector } from "../../../../../../hooks";
import { deletePaymentMethod } from "../../../../../../../../shared/hooks/useFetchPayment";
import ApiUrls from "../../../../../../Utils/axr";
import useBrightspeedHeaders from "../../../../../../hooks/useBrightspeedHeader";
import { toast } from "react-toastify";
import ToastCustonIcon from "../../../../../../SharedComponents/toastCustomIcons";
import { dwLogging } from "../../../../../../../../shared/hooks/useFetchLogin";
import { EC_DW_LOGGING_STEPS } from "../../../../../../../../shared/utils/Constants";
import { QuickBillPay } from "../../../../../../SharedComponents/contents";
import DwLogutil from "../../../../../../Utils/DwLogutil";


export const DeletePaymentSelected = (props: any) => {
  const quickBillPay: any = QuickBillPay();
  const QBP_CONTENT_2 = quickBillPay;

  const user = useAppSelector((state) => state.user.data);
  // const userCompanyName = useAppSelector((state) => state?.user?.companyName);
  const headers = useBrightspeedHeaders();
  const userCompanyName = headers.siteId;
  const sessionId = useAppSelector((state) => state?.user?.sessionId);

  const dispatch = useAppDispatch();
  const [informationCard, setInformationCard] = useState<any>(props.infoCard);
  /*send false to select payment and close the modal from there*/
  const onCloseErrorModal = () => {
    props.closeDialog(false);
  };

  const handleDeletePaymentMethod = async (idPayMethod: any) => {
    try {
      dispatch(onAddEditPaymentMethodLoadingStart());
      const response = await deletePaymentMethod(
        {
          [ApiUrls.deletePaymentMethodUrl_QA]: `${idPayMethod}?ban=${user?.billingAccountNumber}`
        },
        headers
      );

      if (response) {
        dispatch(onAddEditPaymentMethodLoadingStop());
        onCloseErrorModal();
        props.onSuccess();
        toast.success(response?.data?.message || "Success", {
          icon: <ToastCustonIcon type="success" />,
        });
        // dwLogging(
        //   {
        //     "": ApiUrls?.dwLoggingUrl,
        //   },
        //   {
        //     sessionId: sessionId || sessionStorage?.getItem("sessionId") || "",
        //     stepName: EC_DW_LOGGING_STEPS.deleted_payment_method,
        //     cta: "Success",
        //     userEmail: user?.email,
        //     customerType: userCompanyName || "",
        //   },
        //   headers
        // );
         DwLogutil({ stepName: EC_DW_LOGGING_STEPS.deleted_payment_method});
      }
    } catch (error: any) {
      dispatch(onAddEditPaymentMethodLoadingStop());
      console.error(error);
      toast.error(error?.response?.data?.exception?.message || "Something went wrong", {
        icon: <ToastCustonIcon type="error" />,
      });
      // dwLogging(
      //   {
      //     "": ApiUrls?.dwLoggingUrl,
      //   },
      //   {
      //     sessionId: sessionId || sessionStorage?.getItem("sessionId") || "",
      //     stepName: EC_DW_LOGGING_STEPS.deleted_payment_method,
      //     cta: "Success",
      //     userEmail: user?.email,
      //     error: error?.response?.data?.error_description || error?.response?.data?.message || "Something went wrong.",
      //     customerType: userCompanyName || "",
      //   },
      //   headers
      // );
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.deleted_payment_method,
        error: error?.response?.data?.error_description || error?.response?.data?.message || "Something went wrong."
      });
    }
  };

  return (
      // <Box className="GeneralModalBox">
        <Box>
          <Stack direction="row" justifyContent="end"
          sx={{
            position: "absolute",
            right: "24px",
            top: "24px",           
          }}
          >
            <Typography component="button" className="buttonText" onClick={onCloseErrorModal}>
            <img  src={closeIcon} alt="close icon" className="cursor-pointer closeIcon"
              style={{ width: "24px"}}
            />
            </Typography>
          </Stack>
          <Typography variant="h2" color="initial" className="titleErrorPayment" id="scroll-dialog-title">
            {QBP_CONTENT_2?.entry?.qbp_flow?.deletePaymentInfoModal?.title}
          </Typography>

          <Divider className="dividerTitle" role="presentation"/>
          <div  
          // id="scroll-dialog-description"
          >
          <Typography variant="body1" color="initial" className="descriptionErrorPayment text-spacing">
            {QBP_CONTENT_2?.entry?.qbp_flow?.deletePaymentInfoModal?.description}
            </Typography>
            <Typography variant="body1" color="initial" className="descriptionErrorPayment cardTypeCC">
              {informationCard?.cardNumber ? (
                <>
                  {informationCard.creditCardType.toLowerCase()} ****
                  {informationCard.cardNumber.slice(12)}
                </>
              ) : (
                <>
                  {informationCard.type} ****
                  {informationCard.bankAccountNumber.slice(12)}
                </>
              )}
            </Typography>

            {/* {
              QBP_CONTENTS?.entry?.qbp_flow?.review_payment_details
                ?.descriptions?.errorpayment?.message
            } */}
            </div>
          <Stack gap="24px"
            sx={{
              flexDirection: {xs: "column-reverse", sm: "row"},
              marginTop: "40px",
            }}
          >      
               
              <Button className="btnCancel" variant="outlined" onClick={onCloseErrorModal}>
                { QBP_CONTENT_2?.entry?.qbp_flow?.deletePaymentInfoModal?.buttonsLabels?.btnCancel }
              </Button>
          
              <Button
                className="btnConfirm"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (informationCard?.paymentType) {
                    // dispatch(deleteBankPaymentMethod(informationCard.id));
                    handleDeletePaymentMethod(informationCard.id);
                    onCloseErrorModal();
                  }
                }}
              >
                { QBP_CONTENT_2?.entry?.qbp_flow?.deletePaymentInfoModal?.buttonsLabels?.btnConfirm }
              </Button>
          </Stack>
        </Box>
      // </Box>
  );
};
